export const CAREER_START_YEAR = 2021;

/** Year of the promotion to Senior Software Developer */
export const SENIOR_PROMOTION_YEAR = 2026;

export function getYearsOfExperience(now = new Date()) {
  return now.getFullYear() - CAREER_START_YEAR;
}

export function formatYearsOfExperience(now = new Date()) {
  const years = getYearsOfExperience(now);
  return `${years} ${years === 1 ? 'year' : 'years'}`;
}
